import React from 'react'

import { ChevronDoubleDownIcon } from '@heroicons/react/outline'

import ExpandableCard from '../components/ExpandableCard'
import { curriculum_info } from '../data/curriculum'

const CurriculumPage = () => {
  return (
    <>
      <section className="flex flex-col items-center py-8 my-12 px-8 text-center">
        <h1 className="sr-only"> Curriculum </h1>
        <h2 className="text-3xl sm:text-5xl 2xl:text-6xl font-bold">
          Checkout Our <span className="text-primary">Curriculum</span>{' '}
        </h2>
        <p className="mt-6 max-w-2xl sm:text-xl text-center">
          We have curated an intense course curriculum covering everything which
          is in demand in the tech industry from zero to job ready
        </p>
        {/* <Link
          href="/apply"
          className="bg-primary px-4 py-3 mt-8 rounded transition-all hover:bg-primary-dark">
          Apply Now
        </Link> */}
      </section>

      <ChevronDoubleDownIcon className="h-8 w-8 mt-8 mx-auto animate-bounce" />

      <section className="flex flex-col items-center">
        {curriculum_info
          .filter((lesson) => lesson.show)
          .map((item, idx) => (
            <ExpandableCard key={idx} {...item} />
          ))}

        {/* <CurriculumPricing /> */}
      </section>
    </>
  )
}

CurriculumPage.seo = {
  title: 'Curriculum | Devsnest',
  description:
    "Find out the course's structure, what you will learn over the next 7 months, and more about the technologies you will be getting familiar with.",
  canonical: 'https://www.devsnest.in/curriculum',
  openGraph: {
    url: 'https://www.devsnest.in/curriculum'
  }
}

export default CurriculumPage
